import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useTheme } from '@mui/material';
import DeleteIcon from '@mui/icons-material/Delete';
import { AlertDialog } from 'components';
import { Release } from 'services/api/entities';
import distributionApi from 'services/api/distribution';
import { StyledActionIcon } from './styled';

type PropsType = {
  release: Release;
};

const DeleteReleaseButton = ({ release }: PropsType) => {
  const { t } = useTranslation();
  const theme = useTheme();

  const [alertIsOpen, setAlertIsOpen] = useState(false);
  const [deleteRelease] = distributionApi.useDeleteReleaseMutation();

  const handleDeleteRelease = () => {
    deleteRelease({ releaseId: release.id });
    setAlertIsOpen(false);
  };

  return (
    <>
      <StyledActionIcon
        component={DeleteIcon}
        onClick={() => setAlertIsOpen(true)}
      />

      <AlertDialog
        submitButtonStyle={{
          color: theme.palette.error.main,
          backgroundColor: 'initial',
          '&:hover': {
            backgroundColor: theme.palette.grey[200],
          },
        }}
        title={t('distribution:deleteDraftReleaseModal:title')}
        description={t('distribution:deleteDraftReleaseModal:description')}
        closeText={t('general:action:cancel')}
        submitText={t('distribution:deleteDraftReleaseModal:delete')}
        state={{
          isOpen: alertIsOpen,
          isLoading: false,
          error: null,
        }}
        action={{
          onSubmit: handleDeleteRelease,
          onClose: () => setAlertIsOpen(false),
          onExited: () => setAlertIsOpen(false),
        }}
      />
    </>
  );
};

export default DeleteReleaseButton;
